export type SalesDataSourceSaveInternalNotesPayload = {
  id: number
  internalNotes: string
}
